import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ac12aam3a3: FaireBrandEntity = {
  token: "b_ac12aam3a3",
  type: "brand",
  name: "The SOi Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/f93ef3d8e03fe199d8aaa82fe8e497638c8a2c16ee4787ffc57f2e2934cffd6b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/9dfb8f3dc167144b20298eb48d0fc45b19295df769c91a5f7cbe889b6a4fe0e0.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f93ef3d8e03fe199d8aaa82fe8e497638c8a2c16ee4787ffc57f2e2934cffd6b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9dfb8f3dc167144b20298eb48d0fc45b19295df769c91a5f7cbe889b6a4fe0e0.png",
  location: "Modesto, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 594,
  isTopShop: true,
  isInsider: true,
  description:
    "At The SOi Company, fragrance is more than a scent—it’s a feeling, a memory, a moment of calm woven into the everyday. Each candle begins with clean, vegan soy wax and is hand‑poured using perfume‑grade fragrance oils that elevate your space without overwhelming it. Our formulas are free of sulfates, phthalates, and toxins, crafted to burn longer, cleaner, and better for both your home and the planet.\n\nEvery vessel is intentionally designed to live on, whether reimagined as a keepsake jar, drinkware, or a planter. From our signature shimmer glass to our luxurious diffusers, each detail reflects our commitment to beauty, quality, and conscious craftsmanship.\n\nWe create fragrance that helps you slow down, light up, and surround yourself with something that feels unmistakably SOi.\n",
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:42.329Z",
    importedBy: "entity-db-cli",
  },
};
